<template>
    <div>
        <div class="card border-0 m-b-10">
            <div class="card-body">
                <div class="card-text">
                    <ul class="timeline">
                        <li v-for="(item,index) in sortedNews" :key="index">
                            <!-- begin timeline-time -->
                            <div class="timeline-time">
                                <span class="date" v-text="getDayMonth(item.date)"></span>
                                <span class="time" v-text="getMonthOne(item.date)"></span>
                            </div>
                            <!-- end timeline-time -->
                            <!-- begin timeline-icon -->
                            <div class="timeline-icon">
                                <a href="javascript:;">&nbsp;</a>
                            </div>
                            <!-- end timeline-icon -->
                            <!-- begin timeline-body -->
                            <div class="timeline-body">
                                <div class="timeline-header">
                                    <span class="username">
                                        <a href="javascript:;"
                                           v-b-modal.newsShow v-text="item[languageGet]"
                                            @click="selectNews(item)">
                                        </a></span>
                                </div>
                                <div class="timeline-content">
                                    <p v-text="descReturner(item.description)"></p>
                                </div>
                            </div>
                            <!-- end timeline-body -->
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <b-modal id="newsShow" size="xl" :title="selectedNews[languageGet]" ok-only :ok-title="modalAgreeGet" ok-variant="inverse">
            {{selectedNews.description}}
        </b-modal>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: mapGetters(["languageGet", "newsGet","modalAgreeGet"]),
        mounted() {
            this.sortedNews = this.newsGet;
            this.sortedNews = this.sortedNews.forEach((i) => {
                if (typeof i.date == 'string') {
                    let parts = i.date.split('-'),
                        year = parseInt(parts[2], 10),
                        month = parseInt(parts[1], 10) - 1,
                        day = parseInt(parts[0], 10);
                    i.date = new Date(year, month, day);
                }
            });
            this.sortedNews = this.newsGet.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
            });
        },
        methods: {
            descReturner(text) {
                if (text.length > 150) {
                    return text.slice(0, 143) + '...'
                }
            },
            getDayMonth(date){
                return ('0' + date.getDate()).slice(-2)+'.'+('0' + (date.getMonth()+1)).slice(-2);
            },
            getMonthOne(date){
                return date.getFullYear();
            },
            selectNews(item){
                this.selectedNews = item;
            }
        },
        data() {
            return {
                sortedNews: [],
                selectedNews: {}
            }
        }
    }
</script>